import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetDashboardBalance = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.cash.dashboard_balance],
    queryFn: () =>
      cashService.dashboardBalance().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
